import React from 'react';
export function FinalCTA() {
  const productUrl = 'https://lyrasleep.com/products/sleep-gummies';
  return <div className="my-16 bg-gradient-to-br from-purple-600 to-indigo-700 rounded-2xl shadow-2xl p-8 md:p-12 text-center text-white" data-id="element-235">
      <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-236">
        Ready to Finally Sleep Again?
      </h2>
      <p className="text-lg mb-8 opacity-90 max-w-2xl mx-auto" data-id="element-237">
        Join 150,000+ women who've broken free from chronic insomnia
      </p>

      <a href={productUrl} target="_blank" rel="noopener noreferrer" className="bg-white text-purple-600 px-8 py-4 rounded-full text-lg font-bold hover:bg-gray-100 transition-colors duration-200 shadow-lg hover:shadow-xl transform hover:scale-105 transition-transform inline-flex items-center gap-2" data-id="element-238">
        Check Limited Availability
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-239">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" data-id="element-240" />
        </svg>
      </a>

      <p className="text-sm mt-6 opacity-75" data-id="element-241">
        30-Day Money Back Guarantee • No Questions Asked
      </p>
    </div>;
}